<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.successPhoneCallRate.title"
                        [body]="{
                            value: kpi.successPhoneCallRate,
                            precision: texts.successPhoneCallRate.precision,
                            suffix: texts.successPhoneCallRate.suffix,
                        }"
                        [badge]="{
                            value: kpi.successPhoneCallRateEvolution,
                            suffix: texts.successPhoneCallRate.badge.suffix,
                            precision: texts.successPhoneCallRate.badge.precision,
                            style: kpi.successPhoneCallRateEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.successPhoneCallRate.description.title"
                        [descriptionContent]="texts.successPhoneCallRate.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="
                            checkKpiErrors(
                                kpi,
                                'successPhoneCallRate',
                                'successPhoneCallRateEvolution'
                            )
                        "
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.monthlySubscriptionRate.title"
                        [body]="{
                            value: kpi.monthlySubscriptionRate,
                            precision: texts.monthlySubscriptionRate.precision,
                            suffix: texts.monthlySubscriptionRate.suffix,
                        }"
                        [badge]="{
                            value: kpi.monthlySubscriptionRateEvolution,
                            suffix: texts.monthlySubscriptionRate.badge.suffix,
                            precision: texts.monthlySubscriptionRate.badge.precision,
                            style: kpi.monthlySubscriptionRateEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.monthlySubscriptionRate.description.title"
                        [descriptionContent]="texts.monthlySubscriptionRate.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="
                            checkKpiErrors(
                                kpi,
                                'monthlySubscriptionRate',
                                'monthlySubscriptionRateEvolution'
                            )
                        "
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <div class="row g-3">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="callSuccessChart"
                        [title]="texts.phoneCallSuccessRateChart.title"
                        [error]="callSuccessChartError"
                        [isLoading]="!callSuccesschartData()[0].organizationId"
                        [series]="callSuccessChartSeries"
                        [dataLabels]="callSuccessDataLabels"
                        [stacked]="true"
                        [xaxisCategories]="callSuccessXaxisCategories"
                        [yaxis]="callSuccessYaxis"
                        [customTooltip]="callSuccessCustomTooltip"
                        [xaxisTitle]="texts.phoneCallSuccessRateChart.xaxisTitle"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="ctsClientChart"
                        [title]="texts.edfCtsClientRateChart.title"
                        [error]="ctsClientChartError"
                        [isLoading]="!ctsClientchartData()[0].organizationId"
                        [series]="ctsClientChartSeries"
                        [dataLabels]="ctsClientDataLabels"
                        [stacked]="true"
                        [xaxisCategories]="ctsClientXaxisCategories"
                        [yaxis]="ctsClientYaxis"
                        [precision]="texts.edfCtsClientRateChart.precision"
                        [xaxisTitle]="texts.edfCtsClientRateChart.xaxisTitle"
                        [unitTooltip]="texts.edfCtsClientRateChart.unitTooltip"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="selfReportBillsChart"
                        [title]="texts.edfSelfReportBillsRateChart.title"
                        [error]="selfReportBillsChartError"
                        [isLoading]="!selfReportBillschartData()[0].organizationId"
                        [series]="selfReportBillsChartSeries"
                        [dataLabels]="selfReportBillsDataLabels"
                        [stacked]="true"
                        [xaxisCategories]="selfReportBillsXaxisCategories"
                        [yaxis]="selfReportBillsYaxis"
                        [precision]="texts.edfSelfReportBillsRateChart.precision"
                        [xaxisTitle]="texts.edfSelfReportBillsRateChart.xaxisTitle"
                        [unitTooltip]="texts.edfSelfReportBillsRateChart.unitTooltip"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="blueContractChart"
                        [title]="texts.edfBlueContractRateChart.title"
                        [error]="blueContractChartError"
                        [isLoading]="!blueContractchartData()[0].organizationId"
                        [series]="blueContractChartSeries"
                        [dataLabels]="blueContractDataLabels"
                        [stacked]="false"
                        [xaxisCategories]="blueContractXaxisCategories"
                        [yaxis]="blueContractYaxis"
                        [precision]="texts.edfBlueContractRateChart.precision"
                        [grid]="blueContractGrid"
                        [xaxisTitle]="texts.edfBlueContractRateChart.xaxisTitle"
                        [unitTooltip]="texts.edfBlueContractRateChart.unitTooltip"
                        class="h-100">
                    </chart-card>
                </div>
                <chart-card
                    id="blueContractRateComparison"
                    [title]="texts.edfBlueContractRateComparisonChart.title"
                    [error]="blueContractRateComparisonChartError"
                    [isLoading]="!blueContractRateComparisonChartDataSignal()[0].organizationId"
                    [type]="'rangeBar'"
                    [yaxis]="blueContractRateChartYaxis"
                    [dataLabels]="comparisonDataLabels"
                    [series]="blueContractRateComparisonChartSeries"
                    [plotOptions]="comparisonPlotOptions"
                    [customTooltip]="blueContractRateComparisonCustomTooltip"
                    cardClass="h-100"></chart-card>
            </div>
        </div>
    </div>
</div>
